<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>YONEX-SUNRISE G.H. Raisoni Memorial Nagpur District Selection Badminton Tournament 2026</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>YONEX-SUNRISE G.H. Raisoni Memorial Nagpur District Selection Badminton Tournament
                    2026</span></h2>
        </div>
        <p>The YONEX-SUNRISE G.H. Raisoni Memorial Nagpur District Selection Badminton Tournament 2026 was
            successfully conducted from 23rd to 26th July 2026 at Subhedar Badminton Hall, RTMNU Sports Complex,
            Ravi Nagar, Nagpur. The tournament was organized by the Nagpur District Badminton Association in
            association with the G.H. Raisoni Sports & Cultural Foundation, bringing together talented badminton
            players from across the district in a highly competitive sporting environment.</p>

        <p>The four-day championship witnessed an overwhelming response, with 261 players participating through 311
            entries across 22 events, covering Under-9, Under-11, Under-13, Under-15, Under-17, Under-19, Senior,
            and Masters categories. The tournament served as an important district selection event, providing
            players with the opportunity to qualify for higher-level competitions while promoting competitive
            badminton at the grassroots level.</p>

        <p>The tournament featured exciting matches throughout all categories, displaying exceptional skill,
            sportsmanship, and determination from participants. Among the standout performances, Ojas Gedam emerged
            as the Men's Singles Champion, while Arnav Nimbalkar & Sairaj Nayse secured the Men's Doubles title. In
            the junior categories, champions included Ayaan Tamhan (Boys Under-9), Raajnandini Sayam (Girls
            Under-9), Raghav Niwarti (Boys Under-11 & Under-13), Prisha Titare (Girls Under-11), Ira Rokade (Girls
            Under-13), Himank Hajare (Boys Under-15), Anudhya Satpute (Girls Under-15), Sairaj Nayse (Boys Under-17
            & Under-19), Shreeja Wankhede (Girls Under-17 & Under-19), and Mayank Mishra & Zeeshan Khan (Boys
            Under-17 Doubles). The Masters events also witnessed remarkable performances from experienced players
            across the 35+, 45+, 55+, and 60+ categories.</p>

        <p>The successful conduct of the tournament was made possible through the dedicated efforts of the
            organizing committee, officials, referees, coaches, volunteers, and the enthusiastic participation of
            players and their families. The championship reflected the shared commitment of the Nagpur District
            Badminton Association and the G.H. Raisoni Sports & Cultural Foundation towards nurturing sporting
            excellence and providing competitive opportunities for badminton players across all age groups.</p>

        <p>The G.H. Raisoni Sports & Cultural Foundation congratulates all winners, runners-up, participants,
            coaches, and officials for contributing to the grand success of the tournament and looks forward to
            supporting many more sporting events that encourage talent, discipline, and excellence in Indian
            badminton.</p>

        <div class="gall-ery">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys shadow-text-sm">
                        <h4 class="fw-bold">Photos</h4>
                    </div>
                </div>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-2 row-cols-md-3">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-1.webp"
                                alt="YONEX-SUNRISE G.H. Raisoni Memorial Nagpur District Selection Badminton Tournament 2026 | GHRSCF"
                                title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                    alt="GHRSCF" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-2.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-2.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-2.webp"
                                alt="YONEX-SUNRISE G.H. Raisoni Memorial Nagpur District Selection Badminton Tournament 2026 | GHRSCF"
                                title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                    alt="GHRSCF" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-3.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-3.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-3.webp"
                                alt="YONEX-SUNRISE G.H. Raisoni Memorial Nagpur District Selection Badminton Tournament 2026 | GHRSCF"
                                title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                    alt="GHRSCF" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-4.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-4.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-4.webp"
                                alt="YONEX-SUNRISE G.H. Raisoni Memorial Nagpur District Selection Badminton Tournament 2026 | GHRSCF"
                                title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                    alt="GHRSCF" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-5.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-5.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-5.webp"
                                alt="YONEX-SUNRISE G.H. Raisoni Memorial Nagpur District Selection Badminton Tournament 2026 | GHRSCF"
                                title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                    alt="GHRSCF" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>
